<div [ngClass]="['page']" [@fade] *ngIf="isBusy">
  <div class="preloader-wr">
    <div class="preloader">
      <img
        class="preloader__road"
        src="assets/preloader/route.svg"
        alt="preloader"
      />
      <img
        class="preloader__bike"
        src="assets/preloader/bike_2.svg"
        alt="preloader"
      />
      <span
        class="preloader__road-line preloader__road-line_{{ line }}"
        *ngFor="let line of Utility.createRange(1, 24)"
      ></span>
    </div>
    <div
      class="preloader__message"
      *ngIf="requestFallbackMessage || pingRequestBusy"
    >
      {{ requestFallbackMessage || "Проверка сети..." }}
    </div>
  </div>
</div>
